// Audit queries (PG server — reliability feature). Field sets mirror typeDefs/audit.ts.

const AUDIT_TEMPLATE_FIELDS = /* GraphQL */ `
    id
    ownerId
    workspaceId
    name
    description
    requiredPassPercentage
    publicationState
    questionsCount
    questionsOrder
    version
    createdAt
    updatedAt
    createdBy
    updatedBy
    deletedAt
`;

const AUDIT_QUESTION_FIELDS = /* GraphQL */ `
    id
    ownerId
    workspaceId
    auditTemplateId
    text
    points
    photoRequiredToPass
    reference
    version
    createdAt
    updatedAt
    deletedAt
`;

const AUDIT_RUN_FIELDS = /* GraphQL */ `
    id
    ownerId
    workspaceId
    auditTemplateId
    locationId
    auditorId
    status
    score
    maxScore
    percentage
    passed
    answeredCount
    totalQuestions
    startedAt
    completedAt
    version
    createdAt
    updatedAt
    deletedAt
`;

const AUDIT_ASSIGNMENT_FIELDS = /* GraphQL */ `
    id
    ownerId
    workspaceId
    auditTemplateId
    locationId
    assignedUserId
    status
    dueAt
    note
    activeAuditRunId
    completedAuditRunId
    startedAt
    completedAt
    version
    createdAt
    updatedAt
    createdBy
    updatedBy
    deletedAt
`;

const AUDIT_ANSWER_FIELDS = /* GraphQL */ `
    id
    ownerId
    workspaceId
    auditRunId
    auditQuestionId
    answer
    score
    photos
    comment
    createdAt
    updatedAt
`;

export const AUDIT_TEMPLATE_FIELDS_GQL = AUDIT_TEMPLATE_FIELDS;
export const AUDIT_QUESTION_FIELDS_GQL = AUDIT_QUESTION_FIELDS;
export const AUDIT_RUN_FIELDS_GQL = AUDIT_RUN_FIELDS;
export const AUDIT_ASSIGNMENT_FIELDS_GQL = AUDIT_ASSIGNMENT_FIELDS;
export const AUDIT_ANSWER_FIELDS_GQL = AUDIT_ANSWER_FIELDS;

export const listAudits = /* GraphQL */ `
  query listAudits($workspaceId: String!, $publicationState: String, $limit: Int, $nextToken: String) {
    listAudits(workspaceId: $workspaceId, publicationState: $publicationState, limit: $limit, nextToken: $nextToken) {
      items { ${AUDIT_TEMPLATE_FIELDS} }
      nextToken
    }
  }
`;

export const getAudit = /* GraphQL */ `
  query getAudit($id: ID!) {
    getAudit(id: $id) { ${AUDIT_TEMPLATE_FIELDS} }
  }
`;

export const listAuditQuestions = /* GraphQL */ `
  query listAuditQuestions($workspaceId: String!, $auditTemplateId: String!) {
    listAuditQuestions(workspaceId: $workspaceId, auditTemplateId: $auditTemplateId) { ${AUDIT_QUESTION_FIELDS} }
  }
`;

export const listAuditRuns = /* GraphQL */ `
  query listAuditRuns($workspaceId: String!, $auditTemplateId: String, $locationId: String, $limit: Int, $nextToken: String) {
    listAuditRuns(workspaceId: $workspaceId, auditTemplateId: $auditTemplateId, locationId: $locationId, limit: $limit, nextToken: $nextToken) {
      items { ${AUDIT_RUN_FIELDS} }
      nextToken
    }
  }
`;

export const getAuditRun = /* GraphQL */ `
  query getAuditRun($id: ID!) {
    getAuditRun(id: $id) { ${AUDIT_RUN_FIELDS} }
  }
`;

export const listAuditAssignments = /* GraphQL */ `
  query listAuditAssignments($workspaceId: String!, $assignedUserId: String, $status: String, $limit: Int, $nextToken: String) {
    listAuditAssignments(workspaceId: $workspaceId, assignedUserId: $assignedUserId, status: $status, limit: $limit, nextToken: $nextToken) {
      items { ${AUDIT_ASSIGNMENT_FIELDS} }
      nextToken
    }
  }
`;

export const getAuditAssignment = /* GraphQL */ `
  query getAuditAssignment($id: ID!) {
    getAuditAssignment(id: $id) { ${AUDIT_ASSIGNMENT_FIELDS} }
  }
`;

export const listAuditAnswers = /* GraphQL */ `
  query listAuditAnswers($workspaceId: String!, $auditRunId: String!) {
    listAuditAnswers(workspaceId: $workspaceId, auditRunId: $auditRunId) { ${AUDIT_ANSWER_FIELDS} }
  }
`;

export const listAuditResultsByLocation = /* GraphQL */ `
  query listAuditResultsByLocation($workspaceId: String!, $auditTemplateId: String!) {
    listAuditResultsByLocation(workspaceId: $workspaceId, auditTemplateId: $auditTemplateId) {
      items { ${AUDIT_RUN_FIELDS} }
      nextToken
    }
  }
`;

export const auditAnswerStats = /* GraphQL */ `
  query auditAnswerStats($workspaceId: String!, $auditTemplateId: String!) {
    auditAnswerStats(workspaceId: $workspaceId, auditTemplateId: $auditTemplateId) {
      auditQuestionId
      totalAnswers
      yesCount
      noCount
    }
  }
`;

export const listAuditProgress = /* GraphQL */ `
  query listAuditProgress($workspaceId: String!, $auditTemplateId: String, $locationId: String) {
    listAuditProgress(workspaceId: $workspaceId, auditTemplateId: $auditTemplateId, locationId: $locationId) {
      auditTemplateId
      auditTemplateName
      locationId
      locationName
      lastRunId
      lastCompletedAt
      percentage
      passed
      score
      maxScore
      openIssueCount
      assignmentStatus
      assignedTo
    }
  }
`;
